import { spaceCadet } from '@cogneed/react-utils';
import { Box, styled, BoxProps } from '@mui/material';

interface ExtendedBoxProps extends BoxProps {
  hasClient: boolean;
}

const StyledBox = styled((props: ExtendedBoxProps) => {
  const { hasClient, ...otherProps } = props;
  return <Box {...otherProps} />;
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
})(({ hasClient }) => ({
  width: '100%',
  flexGrow: 1,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  '& .MuiTypography-h2': {
    marginTop: 8,
    color: spaceCadet[400],
    fontWeight: 700,
    fontSize: 10,
    lineHeight: '16px',
    paddingLeft: 4,
    flexShrink: 0,
    display: 'flex',
    gap: 4,
    '& svg': {
      fontSize: 13,
      display: 'block',
    },
  },
  '& > .MuiBox-root': {
    padding: 0,
    margin: 0,
    overflowY: 'auto',
    // maxHeight: 'calc(100% - 106px)',
    marginTop: 4,
    flexGrow: 1,
  },
}));
export default StyledBox;
